// extracted by mini-css-extract-plugin
export var copyright = "lcFooter-module--copyright--7c39a";
export var footer = "lcFooter-module--footer--d5db2";
export var logo = "lcFooter-module--logo--e4ac7";